import React from 'react';

import Translate from '../i18n/Translate';

const PromotionsItems = ({ promotion }) => {
  const formatDate = (date) => {
    const dateObj = new Date(date);
    // const month = dateObj.getUTCMonth() + 1;
    const month = dateObj.toLocaleString('es-MX', { month: 'long' });
    const day = dateObj.getUTCDate();
    const year = dateObj.getUTCFullYear();
    return `${day} de ${month} del ${year}`;
  };

  return (
    <div className='promotionsCard'>
      <div className='promotionsCard__image'>
        <img loading='auto' src={promotion.image} alt={promotion.location} />
      </div>

      <div className='promotionsCard__content'>
        <div className='promotionsCard__content__image'>
          {promotion.logo === '' || promotion.logo === undefined ? (
            <div />
          ) : (
            <img loading='auto' src={promotion.logo} alt={promotion.title} />
          )}
        </div>

        <div className='promotionsCard__content__text'>
          <h4 className='promotionsCard__content__text__title'>{promotion.title}</h4>
          <p className='promotionsCard__content__text__subtitle'>{promotion.subtitle}</p>
          <p className='promotionsCard__content__text__duration'>
            {promotion.days <= 9 ? `0${promotion.days}` : promotion.days} días y{' '}
            {promotion.nights <= 9 ? `0${promotion.nights}` : promotion.nights} noches
          </p>
          <p className='promotionsCard__content__text__date'>
            Valido hasta el {formatDate(promotion.validityDate[1])}
          </p>

          <div className='promotionsCard__content__text__price'>
            <div className='promotionsCard__content__text__price-overlay'>
              <p>
                <Translate langkey='promotions.price' />{' '}
                <span>{promotion.price.currency}</span>{' '}
                {Number(promotion.price.amount).toFixed()}{' '}
              </p>
            </div>
            <a
              href={promotion.pdf ? promotion.pdf : promotion.url}
              target='_blank'
              rel='noopener noreferrer'
            >
              {promotion.button}
            </a>
          </div>
        </div>
      </div>

      <div className='promotionsCard__overlay' />
    </div>
  );
};

export default PromotionsItems;
